import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHd"><Path d="M15.2471 14.2793H14.207V9.66992H15.2471C16.541 9.66992 17.2783 10.4756 17.2783 11.9453V11.9551C17.2783 13.4785 16.5654 14.2793 15.2471 14.2793Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM5.4375 8.4541V15.5H6.91211V12.5312H10.0859V15.5H11.5605V8.4541H10.0859V11.3154H6.91211V8.4541H5.4375ZM12.7324 8.4541V15.5H15.4229C17.5371 15.5 18.7822 14.1865 18.7822 11.9502V11.9404C18.7822 9.70898 17.5322 8.4541 15.4229 8.4541H12.7324Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHd;
